import { render, staticRenderFns } from "./Avaluo.vue?vue&type=template&id=699d6712"
import script from "./Avaluo.vue?vue&type=script&lang=js"
export * from "./Avaluo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports